webpackJsonp([141527009537960],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paddedDiv = { paddingBottom: '30px' };
	
	var TechStacks = function TechStacks(_ref) {
	  var data = _ref.data;
	  var dataJson = data.dataJson;
	  var languages = dataJson.languages,
	      frameworksLibs = dataJson.frameworksLibs,
	      databases = dataJson.databases,
	      devTools = dataJson.devTools;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container', style: paddedDiv },
	    _react2.default.createElement(
	      'div',
	      { className: 'content is-large' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'title is-size-4-mobile' },
	        'Tech I know'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'tile is-ancestor' },
	        _react2.default.createElement(
	          'div',
	          { className: 'tile is-vertical is-8' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tile' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-5 is-parent is-vertical' },
	              _react2.default.createElement(
	                'article',
	                { className: 'tile is-child notification is-primary' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'title is-size-4-mobile' },
	                  'Languages'
	                ),
	                languages.map(function (language) {
	                  return _react2.default.createElement(
	                    'p',
	                    { className: 'subtitle is-size-6-mobile', key: language.id },
	                    language.name
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'article',
	                { className: 'tile is-child notification is-info' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'title is-size-4-mobile' },
	                  'Databases'
	                ),
	                databases.map(function (database) {
	                  return _react2.default.createElement(
	                    'p',
	                    { className: 'subtitle is-size-6-mobile', key: database.id },
	                    database.name
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-5 is-parent' },
	              _react2.default.createElement(
	                'article',
	                { className: 'tile is-child notification is-success' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'title is-size-4-mobile' },
	                  'Dev Tools'
	                ),
	                devTools.map(function (devTool) {
	                  return _react2.default.createElement(
	                    'p',
	                    { className: 'subtitle is-size-6-mobile', key: devTool.id },
	                    devTool.name
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-5 is-parent' },
	              _react2.default.createElement(
	                'article',
	                { className: 'tile is-child notification is-warning' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'title is-size-4-mobile' },
	                  'Frameworks & Libraries'
	                ),
	                frameworksLibs.map(function (frameworksLib) {
	                  return _react2.default.createElement(
	                    'p',
	                    { className: 'subtitle is-size-6-mobile', key: frameworksLib.id },
	                    frameworksLib.name
	                  );
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	TechStacks.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = TechStacks;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tech-jsx-e3e984b8e5e1707030ad.js